import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  exitPropertyWalkThroughForm,
  setPropertyWalkThroughFormData,
} from 'src/store/actions/propertyWalkThroughForm';
import {
  exitEasyWalkThroughForm,
  fetchWalkThroughServiceList,
  downloadPDF,
} from 'src/store/actions/easyWalkThroughForm';
import { selectEasyWalkThroughFormData } from 'src/store/selectors/easyWalkThroughForm';
import { selectPropertyWalkThroughFormData } from 'src/store/selectors/propertyWalkThroughForm';
import { stopFormLoading } from 'src/store/actions/loader';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import Loader from '../Loader';
import Row from '../Row';
import Col from '../Col';
import FontAwesomeIcon from '../Icon';
import Avatar from '../Avatar';
import Checkbox from '../Checkbox';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';
import { SuccessMessages } from 'src/common/constants';
import { downloadDocument } from 'src/helpers/DownloadDoc';
import { ToastInfo } from 'src/helpers/validationHelper';

interface ServiceRequestsTableProps {
  serviceRequests: any[];
  checkAttachment: (data: any) => boolean;
  onShowImages: (data: any) => void;
}

const ServiceRequestsTable = ({
  serviceRequests,
  checkAttachment,
  onShowImages,
}: ServiceRequestsTableProps) => {
  return (
    <div className="itemsCompletedTable">
      <table cellPadding="0" cellSpacing="0">
        <thead>
          <tr className="table_head">
            <th className="hide-xs">
              {' '}
              Ticket Number{' '}
            </th>
            <th className="hide-xs">
              {' '}
              Room{' '}
            </th>
            <th className="hide-xs">
              {' '}
              Asset{' '}
            </th>
            <th> Issue Type</th>
            <th> Description</th>
            <th>
              {' '}
              <i aria-hidden="true" className="icon fa-paperclip fal f-20"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          {serviceRequests && serviceRequests.length > 0
            ? serviceRequests.map((data: any) => {
                return (
                  <tr>
                    <td className="hide-xs">
                      {' '}
                      {data.dummyId
                        ? data.dummyId
                        : data.ticketNumber
                          ? data.ticketNumber
                          : data && data.ticketId
                            ? data.ticketId
                            : ''}
                    </td>
                    <td className="hide-xs">
                      {data.area && data.area.name
                        ? data.area.name
                        : data.areaName
                          ? data.areaName
                          : ''}
                    </td>
                    <td className="hide-xs">
                      {data.assetName
                        ? data.assetName
                        : data.asset
                          ? data.asset
                          : ''}
                    </td>
                    <td>
                      {data.serviceType
                        ? data.serviceType
                        : data.issueType && data.issueType.name
                          ? data.issueType.name
                          : data.issueType
                            ? data.issueType
                            : ''}
                    </td>
                    <td>
                      {data.description.substring(
                        0,
                        data.description.length > 20
                          ? '15'
                          : data.description.length
                      ) + (data.description.length < 20 ? '' : '...')}
                    </td>
                    <td style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                      {checkAttachment(data) ? (
                        <div
                          className="avatarImgCenter"
                          onClick={() => onShowImages(data)}
                        >
                          <Avatar
                            badge={
                              JSON.parse(data.attachment).length > 1
                                ? 'count'
                                : ''
                            }
                            url={JSON.parse(data.attachment)[0]}
                          />
                        </div>
                      ) : (
                        <div
                          className="avatarImgCenter"
                          style={{
                            width: '56px',
                            height: '56px',
                            borderRadius: '50%',
                            backgroundColor: '#F4F6F8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          <FontAwesomeIcon
                            glyph="image"
                            weight="light"
                            style={{ color: '#919EAB' }}
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            : null}
        </tbody>
      </table>
    </div>
  );
};

const ReviewWalkThrough = () => {
  const dispatch = useDispatch();

  const easyWalkThroughFormData = useSelector(selectEasyWalkThroughFormData);
  const propertyWalkThroughData = useSelector(
    selectPropertyWalkThroughFormData
  );
  const pdfLoader = useSelector(selectFormLoader);

  const [state, setState] = useState({
    showImages: false,
    selectedImages: [],
    selectedIndex: 0,
  });

  const updateState = (newState: any) => {
    setState((prevState: any) => ({ ...prevState, ...newState }));
  };

  const { showImages, selectedImages, selectedIndex } = state;

  useEffect(() => {
    dispatch(
      fetchWalkThroughServiceList(easyWalkThroughFormData.walkThroughId)
    );
    dispatch(downloadPDF(easyWalkThroughFormData.walkThroughId));
    dispatch(stopFormLoading());
  }, []);

  const showImagesFunc = async (data) => {
    let selectedImage;
    if (data && data.attachment) {
      selectedImage = JSON.parse(data.attachment);
      updateState({
        selectedImages: selectedImage,
        showImages: true,
        selectedIndex: 0,
      });
    }
  };

  const displayImages = () => {
    if (showImages === true) {
      return (
        <ReusableLightbox
          isOpen={showImages}
          onClose={() => updateState({ showImages: false })}
          images={selectedImages}
          initialIndex={selectedIndex || 0}
          onIndexChange={(index) => updateState({ selectedIndex: index })}
        />
      );
    }
  };

  const checkAttachment = (data) => {
    if (data && data.attachment) {
      let attachment = data.attachment.split('/');
      return attachment.length > 0;
    } else if (data && data.Attachment && data.Attachment.length > 0) {
      return data.Attachment.length > 0;
    } else {
      return false;
    }
  };

  const handleClose = async () => {
    dispatch(exitEasyWalkThroughForm());
    dispatch(exitPropertyWalkThroughForm());
    dispatch(
      setPropertyWalkThroughFormData({
        walkthroughData: propertyWalkThroughData.walkthroughData,
      })
    );
  };

  const exportPDF = (pdfurl) => {
    ToastInfo(SuccessMessages.pdfDownloadNotification);
    downloadDocument(pdfurl);
  };

  let serviceRequests: any =
    easyWalkThroughFormData.walkThroughServiceRequests &&
    easyWalkThroughFormData.walkThroughServiceRequests.length > 0
      ? easyWalkThroughFormData.walkThroughServiceRequests
      : [];

  let loading: boolean =
    easyWalkThroughFormData.reviewWalkThroughServiceRequestListLoading &&
    easyWalkThroughFormData.reviewWalkThroughServiceRequestListLoading === true;

  return (
    <>
      <div className="header_section">
        <div className="header_box">
          <div className="header_back_btn">
            <div
              className="back_arrow"
              onClick={() => {
                if (
                  easyWalkThroughFormData &&
                  easyWalkThroughFormData.type === 'Dashboard'
                ) {
                  handleClose();
                } else {
                  dispatch(exitEasyWalkThroughForm());
                  dispatch(exitPropertyWalkThroughForm());
                }
              }}
            >
              <a href="#.">
                <svg
                  width="21"
                  height="18"
                  viewBox="0 0 21 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 7.71429V10.2857H5.25L10.5 15.4286L9.1875 18L0 9L9.1875 0L10.5 2.57143L5.25 7.71429H21Z"
                    fill="#1D1D1D"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div className="configure_heading">
            <h2>Review Walk Through</h2>
          </div>
          <div
            className="back_arrow text-right"
            onClick={() => {
              if (
                easyWalkThroughFormData &&
                easyWalkThroughFormData.type === 'Dashboard'
              ) {
                handleClose();
              } else {
                dispatch(exitEasyWalkThroughForm());
                dispatch(exitPropertyWalkThroughForm());
              }
            }}
          >
            <a href="#.">
              <svg
                width="21"
                height="18"
                viewBox="0 0 21 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.928968 0.929094C1.16339 0.694674 1.48133 0.562977 1.81285 0.562978C2.14437 0.562978 2.46231 0.694674 2.69673 0.929095L8.00003 6.23239L13.3033 0.929094C13.5377 0.694674 13.8557 0.562978 14.1872 0.562978C14.5187 0.562977 14.8367 0.694674 15.0711 0.929094C15.3055 1.16351 15.4372 1.48146 15.4372 1.81298C15.4372 2.1445 15.3055 2.46244 15.0711 2.69686L9.76779 8.00015L15.0711 13.3034C15.3055 13.5379 15.4372 13.8558 15.4372 14.1873C15.4372 14.5188 15.3055 14.8368 15.0711 15.0712C14.8367 15.3056 14.5187 15.4373 14.1872 15.4373C13.8557 15.4373 13.5377 15.3056 13.3033 15.0712L8.00003 9.76792L2.69673 15.0712C2.46231 15.3056 2.14437 15.4373 1.81285 15.4373C1.48133 15.4373 1.16339 15.3056 0.928968 15.0712C0.694548 14.8368 0.562852 14.5188 0.562852 14.1873C0.562853 13.8558 0.694548 13.5379 0.928969 13.3034L6.23226 8.00015L0.928969 2.69686C0.694548 2.46244 0.562853 2.1445 0.562852 1.81298C0.562852 1.48146 0.694548 1.16351 0.928968 0.929094Z"
                  fill="#1D1D1D"
                />
              </svg>
            </a>
          </div>
        </div>
        {loading ? (
          <>
            <div style={{ justifyContent: 'center', alignItems: 'center' }}>
              <Loader center={true} />
            </div>
          </>
        ) : (
          <>
            {pdfLoader && <Loader center={true} />}
            {easyWalkThroughFormData && easyWalkThroughFormData.PDFURL && (
              <div style={{ textAlign: 'right' }}>
                <FontAwesomeIcon glyph="download" weight="light" />
                <a
                  target="blank"
                  style={{ cursor: 'pointer' }}
                  onClick={() => exportPDF(easyWalkThroughFormData.PDFURL)}
                >
                  {' '}
                  Export to PDF
                </a>
              </div>
            )}
            <div className="WalkthroughScroll">
              <ServiceRequestsTable
                serviceRequests={serviceRequests}
                checkAttachment={checkAttachment}
                onShowImages={showImagesFunc}
              />
              {easyWalkThroughFormData.walkthroughChecklistItems &&
                easyWalkThroughFormData.walkthroughChecklistItems.length >
                  0 && (
                  <div className="ChecklistCard walkthroughChecklist">
                    <div className="chack_box_info">
                      <div className="title_chack_box">
                        <h3 className="checklistHead">Walkthrough Checklist</h3>
                      </div>
                      <div className="checklist">
                        <Row>
                          {easyWalkThroughFormData.walkthroughChecklistItems.map(
                            (item, i) => (
                              <Col xs="12" md="3">
                                <div
                                  className="form-check"
                                  style={{ width: '100%' }}
                                >
                                  <Checkbox
                                    label={item.description}
                                    value={item.ischecked}
                                  />
                                </div>
                              </Col>
                            )
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                )}
              <div className="ChecklistCard walkthroughChecklist">
                <div className="chack_box_info">
                  <div className="title_chack_box">
                    <h3 className="checklistHead"> Area Checklist</h3>
                  </div>
                  <div className="checklist">
                    <Row>
                      {easyWalkThroughFormData.areaChecklist &&
                      easyWalkThroughFormData.areaChecklist.length > 0 ? (
                        easyWalkThroughFormData.areaChecklist.map((item, i) => (
                          <>
                            {item.walkthroughChecklistItems.length > 0 && (
                              <Col xs="12" md="6">
                                <>
                                  <div className="checklistSubHead checklistmt-2">
                                    {item.name}
                                  </div>
                                  <Row>
                                    {item.walkthroughChecklistItems.map(
                                      (cl) => (
                                        <Col xs="12" md="6">
                                          <div
                                            className="form-check"
                                            style={{ width: '100%' }}
                                          >
                                            <Checkbox
                                              label={cl.description}
                                              value={cl.ischecked}
                                            />
                                          </div>
                                        </Col>
                                      )
                                    )}
                                  </Row>
                                </>
                              </Col>
                            )}
                          </>
                        ))
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ color: '#DFE3E8' }}>
                            <FontAwesomeIcon
                              weight="regular"
                              glyph="info-circle"
                              size="medium"
                            />
                          </div>
                          <div style={{ marginLeft: 10, color: '#919EAB' }}>
                            {'There are currently no area checklists.'}
                          </div>
                        </div>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
              {easyWalkThroughFormData?.notes?.length > 0 && (
                <div className="ChecklistCard walkthroughChecklist">
                  <div style={{ marginTop: 20 }} className="chack_box_info">
                    <h3 className="checklistHead">Notes</h3>
                    {easyWalkThroughFormData?.notes ?? ''}
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {showImages === true ? <>{displayImages()}</> : null}
    </>
  );
};

export default ReviewWalkThrough;
